import React from 'react';
import CollapsiblePortfolioAllocation from '../features/portfolios/edit/portfolio-allocation/collapsible-portfolio-allocation';
import CommandBar from '../features/portfolios/edit/command-bar/command-bar';

function PortfoliosEditPage() {
  return (
    <div className='flex flex-col lg:flex-row w-full overflow-y-auto'>

      <div className='flex grow overflow-y-auto'>
        <CollapsiblePortfolioAllocation />
      </div>

      <div className='flex lg:h-full'>
        <CommandBar />
      </div>

    </div>
  );
}

export default PortfoliosEditPage;
